/**
 * Injects shopify-forms-suggestion.css into the suggestion page form shadow root.
 * Loaded only from sections/suggestion-hero.liquid.
 */
(function () {
  var STYLE_ID = 'lectron-forms-suggestion-styles';

  var script =
    document.currentScript ||
    document.querySelector('script[src*="shopify-forms-suggestion.js"]');
  var cssUrl = script && (script.dataset.css || script.getAttribute('data-css'));
  var sectionId = script && (script.dataset.section || script.getAttribute('data-section'));

  if (!cssUrl) return;

  function findEmbed() {
    if (sectionId) {
      var root = document.getElementById('suggestion-hero-' + sectionId);
      if (root) {
        var local = root.querySelector('shopify-forms-embed');
        if (local) return local;
      }
    }

    var hero = document.querySelector('.suggestion-hero');
    if (hero) {
      var inHero = hero.querySelector('shopify-forms-embed');
      if (inHero) return inHero;
    }

    return document.querySelector('shopify-forms-embed#app-embed') ||
      document.querySelector('shopify-forms-embed');
  }

  function injectStyles(css) {
    var embed = findEmbed();
    if (!embed || !embed.shadowRoot) {
      requestAnimationFrame(function () {
        injectStyles(css);
      });
      return;
    }

    var shadow = embed.shadowRoot;
    var existing = shadow.getElementById(STYLE_ID);
    if (existing) existing.remove();

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    shadow.appendChild(style);
  }

  /* Placeholders can't be set via CSS, so apply them here.
     Key: selector scoped to the field container; value: placeholder text. */
  var PLACEHOLDERS = [
    {
      selector: '[class*="_formFieldContainer_"]:has(#first_name) input',
      text: 'Jane Smith'
    },
    {
      selector: '[class*="_formFieldContainer_"] textarea',
      text: "Describe your idea, what it does, why it\u2019d help, anything you\u2019d love to see."
    },
    {
      selector: '[id="custom#product_category"]',
      text: 'EV Chargers'
    },
    {
      selector: 'input#email',
      text: 'jane@example.com'
    }
  ];

  function applyPlaceholders(shadow) {
    PLACEHOLDERS.forEach(function (item) {
      shadow.querySelectorAll(item.selector).forEach(function (field) {
        if (field.getAttribute('placeholder') !== item.text) {
          field.setAttribute('placeholder', item.text);
        }
      });
    });
  }

  function watchPlaceholders() {
    var embed = findEmbed();
    if (!embed || !embed.shadowRoot) {
      requestAnimationFrame(watchPlaceholders);
      return;
    }

    var shadow = embed.shadowRoot;
    applyPlaceholders(shadow);

    // Forms re-renders its fields, so re-apply whenever the shadow DOM changes.
    new MutationObserver(function () {
      applyPlaceholders(shadow);
    }).observe(shadow, { childList: true, subtree: true });
  }

  watchPlaceholders();

  fetch(cssUrl)
    .then(function (response) {
      return response.text();
    })
    .then(injectStyles)
    .catch(function (error) {
      console.warn('shopify-forms-suggestion.css failed to load', error);
    });
})();
